
<div *ngIf="showResults; else notYetSearched">
<div *ngIf="showTable; else noStock">
<div class="table-section">
  <div class="table-scroll-container">
    <table *ngIf="showTable" class="ds-table zebra-table fixed-header-table">
      <thead>
      <tr class="table_head">
        <th *ngFor="let column of columnData">{{ column.headerName }}</th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let row of rowsData">
        <td *ngFor="let column of columnData">
          <ng-container *ngIf="column.field === 'image'; else defaultContent">
            <div class="image-popup-wrapper">
              <img
                [src]="row[column.field]"
                alt="Car Image"
                class="car-thumbnail"
              />
              <div class="image-hover-popup">
                <img [src]="row[column.field]" alt="Vehicle Enlarged View" />
              </div>
            </div>
          </ng-container>
          <ng-template #defaultContent>
            <ng-container *ngIf="column.field === 'VIN'; else optionsPopOver">
              <a
                [href]="row[column.field] | unitOverviewLink"
                target="_blank"
                rel="noopener"
                style="
                  font-weight: bold;
                  color: #037493;
                  text-decoration: none;
                  cursor: pointer;"
                title="View Unit Overview"
              >
                {{ row[column.field] }}
              </a>
            </ng-container>
          </ng-template>
          <ng-template #optionsPopOver>
            <ng-container *ngIf="column.field === 'options'; else freeAllocation">
            <span
              style="cursor: pointer; text-decoration: underline"
              [ds-popover-trigger-for]="popover"
              *ngIf="row['options'].length"
            >
              {{ row['options'].length }}
            </span>
              <ds-popover #popover>
                <ds-box-header>Options</ds-box-header>
                <ds-box-content>
                  <ng-container *ngFor="let opt of row['options']">
                    <div>{{ opt.optionCode }}: {{ opt.optionDescription }}</div>
                  </ng-container>
                </ds-box-content>
                <ds-box-footer *ngIf="!row['options'].length">
                  No options
                </ds-box-footer>
              </ds-popover>
            </ng-container>
          </ng-template>
          <ng-template #freeAllocation>
            <ng-container *ngIf="column.field === 'freeAllocation'; else statusCode">
              <a
                style="
                  font-weight: bold;
                  color: #037493;
                  text-decoration: none;
                  cursor: pointer;"
                title="do free allocation"
                (click)="doFs(row['VIN'], row['bodyNo'],row['freeAllocation'])"
              >
                Proceed
              </a>
            </ng-container>
          </ng-template>
          <ng-template #statusCode>
            <ng-container *ngIf="column.field === 'status'; else updateComment">
              <a
                [ngStyle]="{'color': Number(row['status']) === 11 ? '#009966' : Number(row['status']) >= 50 ? '#CC3333' : '#FF6A00'}"
                style="
                  font-weight: bold;
                  color: #037493;
                  text-decoration: none;
                  cursor: pointer;"
                title="Unit Update"
                href="/unit-update?vin={{ row['VIN'] }}&bodyNo={{ row['bodyNo'] }}"
                target="_blank"
                rel="noopener"
              >
                {{ row['status'] }}

              </a>
            </ng-container>
          </ng-template>
          <ng-template #updateComment>
            <ng-container *ngIf="column.field === 'comments'; else actions">
              <a
                style="
                  font-weight: bold;
                  color: #037493;
                  text-decoration: none;
                  cursor: pointer;"
                title="View/Update Comment"
                (click)="updateViewComment(row['comments'], row['bodyNo'], row['VIN'])"
              >
                View Comment
              </a>
            </ng-container>
          </ng-template>
          <ng-template #actions>
            <ng-container *ngIf="column.field === 'action'; else defaultCell">
              <a
                style="
                  font-weight: bold;
                  color: #037493;
                  text-decoration: none;
                  cursor: pointer;"
                title="View Pricing"
                class="action transfer"
                (click)="
                              onPricingClick(
                                row['VIN']
                              )
                            "
                (keydown)="console.log(row['VIN']);

                            "
              >View Pricing </a>
            </ng-container>
          </ng-template>
          <ng-template #defaultCell>
            {{ row[column.field] }}
          </ng-template>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</div>
</div>
</div>
<!--<app-unit-update-modal></app-unit-update-modal>-->
<app-free-allocation-modal></app-free-allocation-modal>
<app-update-comment-modal></app-update-comment-modal>
<app-model-pricing-modal></app-model-pricing-modal>

<ng-template #notYetSearched>
  <div
    class="no-data-message"
    style="
      display: flex;
      align-items: center;
      justify-content: center;
      height: 45vh;
      min-height: 65vh;
      text-align: center;
      padding-left: 2rem;
    "
  >
    <div>
      <h1 style="margin: 0">NO SEARCH RESULTS YET</h1>
      <p style="margin: 0">
        Use the filters and click 'Search' to find what you need.
      </p>
    </div>
  </div>
</ng-template>

<ng-template #noStock>
  <div
    class="no-data-message"
    style="
      display: flex;
      align-items: center;
      justify-content: center;
      height: 45vh;
      min-height: 65vh;
      text-align: center;
      padding-left: 2rem;
    "
  >
    <div>
      <h1 style="margin: 0">NO STOCK AVAILABLE</h1>
      <p style="margin: 0">
        Try adjusting your filters or search criteria to find available results.
      </p>

    </div>
  </div>
</ng-template>

